export const paths = {
  NEW: 'new',
  VERIFY: 'verify',
  DELETE: 'delete',
}

export const mobileNumberLinks = {
  newMobileNumberLink: () => `/${paths.NEW}`,
  verifyMobileNumberLink: () => `/${paths.VERIFY}`,
  deleteMobileNumberLink: () => `/${paths.DELETE}`,
}

export type MobileNumberLinks = typeof mobileNumberLinks
